<div class="media-call-buttons">
    <qai-call-button
      [label]="('call.PAUSE_LABEL' | transloco)"
      [kind]="'tertiary'"
      [icon]="isPaused ? 'play' : 'pause'"
      [disabled]="!isPauseEnabled"
      *ngIf="showPauseButton"
      (clicked)="handlePlaybackClick()"
    />

  <qai-call-button
    [label]="('call.AUDIO'| transloco)"
    [kind]="isMicOn ? 'tertiary' : 'destructive'"
    [icon]="isMicOn ? 'microphone' : 'microphone-off'"
    (clicked)="handleMicrophoneClick()"
    [disabled]="disableMicButton"
  />
</div>

<button
  class="endCallButton"
  qai-button
  size="small"
  kind="destructive"
  [disabled]="disableEndCallButton"
  (click)="handleEndCallClick()"
>
  <qai-icon kind="phone-call" positionStart />
  {{'call.END_CALL' | transloco}}
</button>
